export const coreAddresses = {
  balanceTracker: "0x6e6e1e4FB3Ee6C074f10d3f80E0d3541accf7c2b",
  eVaultFactory: "0x42388213C6F56D7E1477632b58Ae6Bba9adeEeA3",
  eVaultImplementation: "0x8346BeBaA0789Eb92CFfCC07033b8bF9f3eFdcAB",
  eulerEarnFactory: "0xA3843A73e6a9F81309B931237Ca4759B3B02ff0E",
  evc: "0x7bdbd0A7114aA42CA957F292145F6a931a345583",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x593Ab8A0182f752c6f1af52CA2A0E8B9F868f64A",
  sequenceRegistry: "0x3cf6e4c11333b30f0D0CEAe6B78f53a660df357c",
} as const
